export enum KeyWatcherType {
  Combo = 'combo',
  Press = 'press',
  Release = 'release'
}
